<template>
    <FileUploader v-if="isopenfileuploader" @kirimthesefiles="triggerkirim"
        @tutupfileuploader="isopenfileuploader = false" ref="fileuploader" />
    <div class="containerview" v-if="chatactive">
        <div class="header-contain">
            <div class="btns">
                <button title="tandai tiket" @click="tandaichat">
                    <i class="fa-slab fa-regular fa-bookmark"></i>
                </button>
                <!-- <button title="simpan tiket">
          <i class="fa-slab fa-regular fa-box-archive"></i>
        </button> -->
                <button title="close tiket" @click="closeTicket">
                    <i class="fa-slab fa-regular fa-folder"></i>
                </button>
                <button class="nama-p">
                    <p>
                        <small>{{ currentTiketState.namaperusahaan }}</small>
                    </p>
                </button>
            </div>
        </div>
        <div class="body-contain">
            <div class="header-body-contain">
                <div class="notiket">
                    <p>{{ chatactive.no_tiket }}</p>
                    <p v-if="chatactive.ditandai" class="tag">
                        <i class="fa-solid fa-bookmark"></i> ditandai
                    </p>
                </div>
                <h3>{{ chatactive.getpengaduan()?.name }}</h3>
            </div>

            <div class="main-container-isi" ref="containerchat">
                <div class="card-message" v-for="(item, index) in currentactivechat" :key="index">
                    <p class="error-msg" v-if="item?.senderror">
                        <i class="fa-jelly fa-regular fa-triangle-exclamation"></i> pesan
                        tidak terkirim
                    </p>
                    <div class="name-poin">
                        <h5>
                            {{
                                item.sender.perusahaan === null
                                    ? item?.sender?.username
                                    : item?.sender?.perusahaan?.nama_perusahaan
                            }}
                            {{
                                item.sender["perusahaan"] === undefined
                                    ? item.sender.username
                                    : ""
                            }}
                        </h5>

                        <button title="batal kirim chat" @click="batalkirim(item)" v-if="item.sender.role_id != 3">
                            <i class="fa-duotone fa-light fa-message-slash"></i>
                        </button>
                    </div>

                    <p>
                        <small>@{{ item.sender.username }}</small>
                    </p>
                    <p>
                        <small>{{ item.sent_at }}</small>
                    </p>

                    <div class="attach" @click="bukafile(getmessageorfile(item)?.file)"
                        v-if="getmessageorfile(item).type != 'msg'">
                        <i class="fa-jelly-duo fa-regular fa-file"></i>
                        <p>{{ getmessageorfile(item).file.split("/")[1] }} {{ item.file }}</p>
                    </div>
                    <p v-if="getmessageorfile(item).type == 'msg'">
                        {{ getmessageorfile(item).msg }}
                    </p>
                </div>
            </div>
        </div>
        <div class="footer-contain">
            <div class="inputan-chat">
                <textarea name="" id="" v-model="textinputan" maxlength="1000" rows="5"
                    placeholder="ketik pesan kamu disini..."></textarea>
                <div class="inputan-bottom">
                    <div class="kiri">
                        <button class="btn-kirim" @click="addMessage()" :disabled="pesandikirim">
                            <p v-if="!pesandikirim">kirim pesan</p>
                            <p v-if="pesandikirim">
                                <i class="fa-duotone fa-solid fa-spinner-third"></i>pesan
                                dikirim
                            </p>
                        </button>

                        <div class="select-wrapper">
                            <select class="listpilih" v-model="pilihanjawaban" @change="pilihjawaban()">
                                <option value="#" selected>Pilihan</option>

                                <option v-for="(itemjawaban, index) in listJawaban" :key="index"
                                    :value="itemjawaban.isi">
                                    {{ itemjawaban.judul }}
                                </option>
                            </select>

                            <i class="fa-solid fa-chevron-down"></i>
                        </div>

                        <div class="info-warning" v-if="pesankosong">
                            <i class="fa-slab fa-regular fa-triangle-exclamation"></i>
                            <p><small>kamu tidak mengetik pesan apapun</small></p>
                        </div>
                    </div>
                    <div class="kanan">
                        <button class="btn-file" @click="
                            textinputan = '';
                        pilihanjawaban = '#';
                        " title="clear chat">
                            <i class="fa-sharp fa-solid fa-trash"></i>
                        </button>
                        <button class="btn-file" title="pilih file" @click="isopenfileuploader = true">
                            <i class="fa-jelly fa-regular fa-paperclip"></i>
                        </button>
                        <p>
                            <small>{{ lengthtext }}/1000</small>
                        </p>
                        <input type="file" name="" id="" style="display: none" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getCookie } from "@/assets/config/cookie";
import { backend, websocket } from "@/assets/config/server";
import lj from "@/assets/params/ListJawaban.json";
import FileUploader from "@/models/FileUploaderModel.vue";
import { io } from "socket.io-client";
import {
    sendMessage,
    setupdataraw,
    kirimchatsocket as kirimtouser,
    generateUniqueId as kodeunikgen,
    batalkirimchat
} from "@/utils/chatcontrol";
import { kirimfiles } from "@/utils/filescontrol";
import Swal from "sweetalert2";

export default {
    name: "ContainerView",
    data() {
        return {
            textinputan: "",
            listJawaban: lj,
            pilihanjawaban: "#",
            sessiontoken: null,
            datauser: JSON.parse(getCookie("loginInfo")),
            pesandikirim: false,
            pesankosong: false,
            isopenfileuploader: false,
            socket: io(websocket),
        };
    },
    props: {
        chatactive: Object,
        currentTiketState: Object,
    },
    emits: ["tandai", "updatepesanerror", "updatedata", "closethisticket", "updatedatachat", "batalkirimchat"],
    components: { FileUploader },
    mounted() {
        this.sessiontoken = this.datauser.token
    },
    computed: {
        currentactivechat() {
            return this.chatactive
                .getmessage()
        },
        lengthtext() {
            return this.textinputan.length;
        },
        datetimenow() {
            const now = new Date();

            const datetime = now
                .toLocaleString("sv-SE", {
                    timeZone: "Asia/Jakarta",
                })
                .replace("T", " ");

            return datetime;
        },
    },
    methods: {
        bukafile(file) {
            console.log(file)
            if (file.includes(backend)) {
                window.open(file, '_blank')
            } else {
                window.open(`${backend}/storage/${file}`, '_blank')
            }
        },
        async kirimfilesfun(params) {
            const data = {
                token: this.sessiontoken,
                idtiket: this.currentTiketState.idtiket,
            }

            if (params.type.includes("image")) {
                data.image = params.file
            } else if (params.type.includes("application")) {
                data.file = params.file
            }

            const response = await sendMessage(data)

            console.log(response)
            console.log(params)

            if (response?.status == 201) {
                this.pesandikirim = true;

                const filedikirim = response.data
                const element = filedikirim.pengaduan

                console.log(filedikirim)

                var kodeunik = kodeunikgen();
                const datasetup = setupdataraw({
                    id: this.chatactive.id,
                    msg: null,
                    file: element.file_pengaduan,
                    gambar: element.gambar_pengaduan,
                    gambar_thumb: element.gambar_pengaduan,
                    nama_perusahaan: this.datauser.username,
                    role_id: this.datauser.role_id,
                    user_id: this.datauser.id,
                    username: this.datauser.username,
                    kodeunik: kodeunik,
                });

                this.$emit("updatedata", {
                    tiket: this.currentTiketState.no_tiket,
                    ...datasetup,
                });
                this.kirimchatsocket({
                    message: null,
                    file: element.file_pengaduan,
                    img: element.gambar_pengaduan,
                });

                Swal.fire({
                    titleText: 'Berhasil Kirim Files',
                    text: 'Semua files berhasil dikirim',
                    icon: 'success',
                })

                this.$refs.fileuploader.tutupFileUploader()
                this.pesandikirim = false;
                this.textinputan = "";
            } else {
                Swal.fire({
                    titleText: 'Gagal Kirim Files',
                    text: response,
                    icon: 'success',
                })
            }
        },
        async triggerkirimbefore(params) {
            console.log(params)
            for (const item of params) {
                await this.kirimfilesfun(item);
            }
        },
        async triggerkirim(params) {
            const response = await kirimfiles(params, this.currentTiketState.idtiket, this.sessiontoken)
            console.log(response)
            console.log(params)

            if (response?.status == 200) {
                this.pesandikirim = true;

                const filedikirim = response.data.data

                filedikirim.forEach(element => {
                    var kodeunik = kodeunikgen();
                    const datasetup = setupdataraw({
                        id: element.id,
                        tiket_id: element.tiket_id,
                        msg: null,
                        file: element.file_pengaduan,
                        gambar: element.gambar_pengaduan,
                        gambar_thumb: element.gambar_pengaduan,
                        nama_perusahaan: this.datauser.username,
                        role_id: this.datauser.role_id,
                        user_id: this.datauser.id,
                        username: this.datauser.username,
                        kodeunik: kodeunik,
                    });

                    console.log('isis data setup containerview ', datasetup)

                    this.$emit("updatedata", {
                        tiket: this.currentTiketState.no_tiket,
                        ...datasetup,
                    });
                    this.kirimchatsocket({
                        message: null,
                        file: element.file_pengaduan,
                        img: element.gambar_pengaduan,
                    });
                });

                Swal.fire({
                    titleText: 'Berhasil Kirim Files',
                    text: 'Semua files berhasil dikirim',
                    icon: 'success',
                })

                this.$refs.fileuploader.tutupFileUploader()
                this.pesandikirim = false;
                this.textinputan = "";
            } else {
                Swal.fire({
                    titleText: 'Gagal Kirim Files',
                    text: response,
                    icon: 'success',
                })
            }
        },
        tandaichat() {
            this.$emit("tandai");
        },
        pilihjawaban() {
            this.textinputan = this.pilihanjawaban;
        },
        cekpanjang() { },
        getmessageorfile(data) {
            //console.log(data)
            if (data?.file_pengaduan) {
                const datafileorimg = data.file_pengaduan.replaceAll(
                    `${backend.toString()}/storage/`,
                    "",
                );
                return {
                    type: "file",
                    msg: "Mengirim File",
                    file: datafileorimg,
                };
            } else if (data?.gambar_pengaduan) {
                const datafileorimg = data.gambar_pengaduan.replaceAll(
                    `${backend.toString()}/storage/`,
                    "",
                );
                return {
                    type: "img",
                    msg: "Mengirim Gambar",
                    file: datafileorimg,
                };
            }

            return { type: "msg", msg: data?.message };
        },

        openfile() { },
        scrollBottom() {
            this.$nextTick(() => {
                const el = this.$refs.containerchat;

                if (!el) return;

                el.scrollTo({
                    top: el.scrollHeight,
                    behavior: "smooth",
                });
            });
        },
        kirimchatsocket({ message, file, img }) {
            const req = kirimtouser({
                id: 1,
                role_id: this.datauser.role_id,
                username: this.datauser.username,
                file: file,
                img: img,
                message: message,
                no_tiket: this.chatactive.no_tiket,
                tiket_id: this.chatactive.id,
                wholetiket: this.chatactive
            });
            return req;
            //console.log(req);
        },
        async addMessage() {
            if (this.textinputan.replaceAll(" ", "") == "") {
                this.pesankosong = true;
                setTimeout(() => {
                    this.pesankosong = false;
                }, 2000);
                return;
            }
            this.pesandikirim = true;
            var kodeunik = kodeunikgen();
            var pesan = this.textinputan;

            const datasetup = setupdataraw({
                id: this.chatactive.id,
                msg: this.textinputan,
                nama_perusahaan: this.datauser.username,
                role_id: this.datauser.role_id,
                user_id: this.datauser.id,
                username: this.datauser.username,
                kodeunik: kodeunik,
            });

            this.$emit("updatedata", {
                tiket: this.currentTiketState.no_tiket,
                ...datasetup,
            });

            this.kirimchatsocket({
                message: this.textinputan,
                file: null,
                img: null,
            });

            this.textinputan = "";
            const sent = await sendMessage({
                token: this.sessiontoken,
                idtiket: this.currentTiketState.idtiket,
                message: pesan,
            });

            if (sent.status != 201) {
                this.$emit("updatepesanerror", {
                    notiket: this.currentTiketState.no_tiket,
                    kodeunik: kodeunik,
                });
                this.textinputan = pesan;
            } else {
                const idchat = await sent.data?.pengaduan.id
                console.log('isi return dari sent : ', idchat)
                this.triggerUbahDataChat(this.currentTiketState.no_tiket, kodeunik, idchat)
                this.pilihanjawaban = "#";
            }

            this.pesandikirim = false;
        },

        triggerUbahDataChat(notiket, kodeunik, idchat) {
            this.$emit("updatedatachat", {
                idchat: idchat,
                notiket: notiket,
                kodeunik: kodeunik,
            });
        },

        closeTicket() {
            this.$emit("closethisticket", this.currentTiketState.idtiket, this.currentTiketState.no_tiket);
        },
        async batalkirim(item) {
            const data = [item.file_pengaduan, item.gambar_pengaduan, item.message].filter(el => el !== null)

            console.log("isi item :")
            console.log(item)

            const send = await batalkirimchat(
                item.id,
                this.currentTiketState.no_tiket,
                this.currentTiketState.idtiket,
                this.datauser.id,
                data,
                this.sessiontoken
            )

            const detailresponse = await send.data

            if (send.status == 200) {
                this.$emit("batalkirimchat", {
                    ...detailresponse
                });

                const dataUnsend = {
                    username: this.datauser.username,
                    no_tiket: detailresponse?.data.no_tiket,
                    idchat: detailresponse?.data.idchat,
                    idtiket: detailresponse?.data.idtiket
                };

                console.log("DATA YANG AKAN DI-EMIT:", dataUnsend);


                this.socket.emit("unsend", {
                    ...dataUnsend
                })

                console.log("isi response ",detailresponse)
            }

            //console.log("response : ", detailresponse)
        }
    },
};
</script>
<style scoped>
.containerview {
    width: 100%;
    height: 100vh;
    background-color: white;
    overflow: hidden;

    display: grid;
    grid-template-rows: max-content auto max-content;

    min-height: 0;
}

.header-contain {
    padding: 20px;
    border-bottom: 1px solid #dadada;

    display: grid;
    grid-template-columns: auto max-content;

    box-sizing: border-box;

    .btns {
        display: flex;

        button:last-child {
            width: max-content;
            padding-left: 10px;
            padding-right: 10px;
            font-size: 10pt;
        }
    }
}

.header-contain button {
    cursor: pointer;
    height: 30px;
    width: 30px;
    font-size: 12pt;
    color: black;
    border-radius: 3px;
    border: none;
    margin-right: 10px;
}

.body-contain {
    height: 100%;

    display: grid;
    grid-template-rows: max-content auto;

    min-height: 0;
    overflow: hidden;
}

.header-body-contain {
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #dadada;
    background-color: white;
}

.notiket {
    display: flex;
    align-items: center;
}

.notiket h5 {
    font-family: poppins-reg;
    color: #959595b8;
}

.notiket .tag {
    margin-left: 20px;
    font-size: 10pt;
    background-color: #e8f4ff;
    color: #098cff;
    padding: 3px 8px;
    border-radius: 5px;
}

.main-container-isi {
    overflow-y: auto;
    overflow-x: hidden;

    min-height: 0;
    height: 100%;

    padding: 0px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    gap: 0;

    background-color: #f5f5f5;
}

.card-message {
    background-color: white;
    padding: 15px;
    border-radius: 0px;
    border-bottom: 1px solid #dadada;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.card-message .error-msg {
    margin-bottom: 10px;
    cursor: pointer;
    background-color: #ffe5e5;
    color: red;
    padding: 3px 8px;
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;

    i {
        margin-right: 5px;
    }

    a {
        margin-left: 5px;
    }
}

.card-msg-error {
    background-color: #ffe5e5;
    color: red;
    padding: 3px 8px;
    width: max-content;
    border-radius: 5px;
    font-size: 10pt;
}

.card-message .name-poin {
    display: flex;

    button {
        margin-left: 10px;
        border: 1px solid #dadada;
        border-radius: 100%;
        height: 20px;
        font-size: 8pt;
        width: 20px;
        cursor: pointer;
        color: red;
    }
}

.card-message h5 {
    margin: 0;
    font-size: 11pt;
}

.card-message .attach {
    cursor: pointer;
    width: max-content;
    max-width: 500px;
    height: max-content;
    border: 1px solid #dadada;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: whitesmoke;
    border-radius: 8px;
    padding: 7px 10px;

    i {
        color: red;
    }

    p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 9pt;
        margin-left: 5px;
    }
}

.card-message .attach:hover {
    background-color: #e8f4ff;
}

.card-message small {
    color: #888;
}

.card-message p {
    margin-top: 3px;
    margin-bottom: 0;
    line-height: 1.5;
    font-size: 10pt;
}

.footer-contain {
    padding: 15px 20px;
    border-top: 1px solid #dadada;
    background-color: white;
    box-sizing: border-box;

    .inputan-chat {
        box-sizing: border-box;
        border-radius: 10px;
        padding: 0px;
        width: max-content;
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        border: 2px solid #dadada;

        textarea {
            padding: 15px 15px;
            font-family: poppins-reg;
            width: 100%;
            box-sizing: border-box;
            background-color: none;
            border: none;
            outline: none;
        }

        .inputan-bottom {
            padding: 15px 15px;
            box-sizing: border-box;
            width: 100%;
            border-top: 2px solid #dadada;
            height: max-content;
            display: grid;
            grid-template-columns: auto max-content;

            .kiri {
                display: flex;

                .info-warning {
                    background-color: #ffe5b4;
                    display: flex;
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    margin-bottom: 30px;
                    align-items: center;
                    color: orange !important;
                    margin-left: 30px;
                    width: max-content;
                    max-width: 250px;
                    padding: 5px 8px;
                    border-radius: 5px;

                    p {
                        margin-left: 5px;
                        color: orange;
                        text-align: left;
                    }
                }

                .select-wrapper {
                    position: relative;
                    width: 250px;
                }

                .listpilih {
                    width: 100%;
                    margin-left: 14px;

                    padding: 8px 35px 8px 12px;

                    border: 1px solid #dadada;
                    border-radius: 6px;

                    background-color: white;

                    font-family: poppins-reg;
                    font-size: 9pt;

                    outline: none;
                    cursor: pointer;

                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;

                    text-overflow: ellipsis;
                }

                .listpilih:focus {
                    border-color: #098cff;
                    box-shadow: 0 0 0 3px rgba(9, 140, 255, 0.1);
                }

                .select-wrapper i {
                    position: absolute;

                    right: 12px;
                    top: 50%;

                    transform: translateY(-50%);

                    pointer-events: none;

                    color: #666;
                    font-size: 9pt;
                }
            }

            .btn-kirim {
                width: 160px;
                padding: 8px 20px;
                cursor: pointer;
                background-color: #098cff;
                color: white;
                border: none;
                font-size: 9pt;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: poppins-reg;

                p,
                i {
                    color: white;
                }

                p {
                    margin-left: 0;
                    padding: 0;
                }

                i {
                    margin-right: 8px;
                }
            }

            .kanan {
                display: grid;
                align-items: center;
                box-sizing: border-box;
                grid-template-columns: repeat(10, max-content);
            }

            .btn-file {
                background-color: none;
                border: none;
                margin-right: 10px;
                padding: 7px;
                cursor: pointer;
            }

            .btn-file:hover {
                background-color: #dadada;
            }

            p {
                font-size: 10pt;
                width: max-content;
                text-align: right;
                color: #888;
            }
        }
    }
}
</style>
